import React, { Fragment } from "react";


import BannedCashregisterForm from "./EventTypeForm";
import EditPage from "../../../../../Components/Extends/EditPage";
import Edit from "../../../../../Components/Edit/Edit";
import Navbar from "../../Navbar";
import localize from "helpers/localize";

class EditEventType extends EditPage {
  getPageTitle = () => {
    if (this.isViewPage()) {
      return localize("cashregisters", "Esemény tipus megtekintése");
    }
    return this.props.match.params.id
      ? localize("cashregisters", "Esemény tipus szerkesztése")
      : localize("cashregisters", "Esemény tipus létrehozása");
  };
  render() {
    return (
      <Fragment>
        <Navbar {...this.props} />
        <Edit
          getPagetitle={this.getPageTitle}
          isViewPage={this.isViewPage()}
          {...this.props}
        >
          <BannedCashregisterForm
            {...this.props}
            isViewPage={this.isViewPage()}
          />
        </Edit>
      </Fragment>
    );
  }
}

export default EditEventType;



// WEBPACK FOOTER //
// ./src/Containers/Pages/Cashregisters/EventTypes/views/EditEventType.js